export const subsIitialState = {
    subList: []
};